import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsD3DotJsComponent } from './simple-icons-d3-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsD3DotJsComponent ],
    exports:      [ SimpleIconsD3DotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsD3DotJsModule {}
